(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-factory-catalog]').forEach(catalog => {
      if (catalog.dataset.ready) return;
      catalog.dataset.ready = 'true';
      const cards = [...catalog.querySelectorAll('[data-factory-model]')];
      const initialField = document.getElementById('FactoryModelCodes');
      const selected = new Set((initialField?.value || '').split(/\n+/).map(value => value.trim()).filter(Boolean));
      const sync = () => {
        catalog.querySelector('[data-factory-selection]').textContent = selected.size ? [...selected].join(' · ') : catalog.dataset.emptySelection;
        catalog.querySelector('[data-factory-status]').textContent = catalog.dataset.selectedTemplate.replace('__COUNT__', selected.size);
        cards.forEach(card => {
          const button = card.querySelector('[data-factory-add]');
          const on = selected.has(card.dataset.factoryModel);
          button.setAttribute('aria-pressed', String(on));
          button.textContent = on ? catalog.dataset.addedLabel : catalog.dataset.addLabel;
        });
        const field = document.getElementById('FactoryModelCodes');
        if (field) field.value = [...selected].join('\n');
      };
      catalog.querySelectorAll('[data-factory-group]').forEach(group => {
        const groupCards = [...group.querySelectorAll('[data-factory-model]')];
        const more = group.querySelector('[data-factory-more]');
        let limit = 8;
        const render = () => {
          groupCards.forEach((card, index) => { card.hidden = index >= limit; });
          more.hidden = limit >= groupCards.length;
        };
        more.addEventListener('click', () => { limit += 8; render(); });
        render();
      });
      catalog.addEventListener('click', event => {
        const button = event.target.closest('[data-factory-add]');
        if (!button) return;
        const model = button.closest('[data-factory-model]').dataset.factoryModel;
        selected.has(model) ? selected.delete(model) : selected.add(model);
        sync();
      });
      catalog.querySelector('[data-factory-clear]').addEventListener('click', () => { selected.clear(); sync(); });
      catalog.querySelector('[data-factory-quote]').addEventListener('click', () => {
        const program = document.getElementById('WholesaleQuoteProgram');
        if (program) {
          const option = [...program.options].find(option => option.textContent === 'Factory-direct production');
          if (option) program.value = option.value;
          program.dispatchEvent(new Event('change', { bubbles: true }));
        }
        sync();
      });
      catalog.querySelectorAll('[data-factory-enhanced]').forEach(element => { element.hidden = false; });
      sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
